import Vue from 'vue'
import Vuex from 'vuex'
import app from "./app"
import permission from "./permission"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app,
    permission
  }
})
